/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Gpfundcontribution3Inputs */

const en_coinvestments_gpfundcontribution3 = /** @type {(inputs: Coinvestments_Gpfundcontribution3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GP Fund Contribution`)
};

/**
* | output |
* | --- |
* | "GP Fund Contribution" |
*
* @param {Coinvestments_Gpfundcontribution3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_gpfundcontribution3 = /** @type {((inputs?: Coinvestments_Gpfundcontribution3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Gpfundcontribution3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_gpfundcontribution3(inputs)
});
export { coinvestments_gpfundcontribution3 as "coInvestments_gpFundContribution" }